/*
 * Môdern Space Gallery Wishlist
 * ------------------------------------------------------------
 * Browser-based wishlist (localStorage). No account required.
 * Persists per browser/device only — not synced across devices.
 *
 * Any element with [data-wishlist-toggle] + [data-wishlist-id]
 * becomes a working heart button, as long as it also carries:
 *   data-wishlist-title
 *   data-wishlist-url
 *   data-wishlist-image (optional)
 *   data-wishlist-price (optional, numeric string)
 *
 * Folders: items can optionally belong to a named folder (e.g. a Budget
 * Planner list saved as "Living Room — $1,000 Budget"). Items saved via a
 * plain heart button (the common case, across every product card sitewide)
 * have folder = null and are grouped under "Saved Items" on the wishlist page.
 */
(function () {
  var STORAGE_KEY = 'msg_wishlist_v1';
  var EVENT_NAME = 'wishlist:updated';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { items: items } }));
  }

  function isSaved(id) {
    return getWishlist().some(function (item) { return item.id === id; });
  }

  // folder is optional. If the id already exists, its folder is left as-is
  // (first save wins) rather than moved — a deliberate simplification so an
  // item doesn't silently jump between a manually-hearted save and a
  // Budget-Planner folder save.
  function addItem(item, folder) {
    var items = getWishlist();
    if (items.some(function (i) { return i.id === item.id; })) return items;
    var toAdd = {
      id: item.id,
      title: item.title,
      url: item.url,
      image: item.image,
      price: item.price,
      folder: folder || null,
      savedAt: Date.now()
    };
    items.unshift(toAdd);
    saveWishlist(items);
    return items;
  }

  function removeItem(id) {
    var items = getWishlist().filter(function (i) { return i.id !== id; });
    saveWishlist(items);
    return items;
  }

  function toggleItem(item, folder) {
    if (isSaved(item.id)) {
      removeItem(item.id);
      return false;
    } else {
      addItem(item, folder);
      return true;
    }
  }

  // Returns folder names in the order their most-recent item was saved,
  // most-recent first. null (unfiled) is handled separately by the caller.
  function getFolders() {
    var items = getWishlist();
    var seen = {};
    var order = [];
    items.forEach(function (item) {
      if (item.folder && !seen[item.folder]) {
        seen[item.folder] = true;
        order.push(item.folder);
      }
    });
    return order;
  }

  function getByFolder(folder) {
    return getWishlist().filter(function (item) { return (item.folder || null) === (folder || null); });
  }

  function readItemFromEl(el) {
    return {
      id: el.getAttribute('data-wishlist-id'),
      title: el.getAttribute('data-wishlist-title') || '',
      url: el.getAttribute('data-wishlist-url') || '',
      image: el.getAttribute('data-wishlist-image') || '',
      price: el.getAttribute('data-wishlist-price') || ''
    };
  }

  function refreshButtonState(el) {
    var id = el.getAttribute('data-wishlist-id');
    if (!id) return;
    el.classList.toggle('is-saved', isSaved(id));
    el.setAttribute('aria-pressed', isSaved(id) ? 'true' : 'false');
  }

  function refreshAllButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    Array.prototype.forEach.call(buttons, refreshButtonState);
    updateCountBadges();
  }

  function updateCountBadges() {
    var count = getWishlist().length;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    Array.prototype.forEach.call(badges, function (b) {
      b.textContent = count;
      b.hidden = count === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var item = readItemFromEl(btn);
    if (!item.id) return;
    toggleItem(item);
    refreshAllButtons();
  });

  document.addEventListener(EVENT_NAME, updateCountBadges);
  document.addEventListener('DOMContentLoaded', refreshAllButtons);
  if (document.readyState !== 'loading') refreshAllButtons();

  window.MSGWishlist = {
    get: getWishlist,
    isSaved: isSaved,
    add: addItem,
    remove: removeItem,
    toggle: toggleItem,
    refresh: refreshAllButtons,
    getFolders: getFolders,
    getByFolder: getByFolder
  };
})();
